import React, { useEffect, useState } from 'react';
import PortsAutoComplete from 'components/common/PortsAutoComplete';
import _ from 'lodash';
import api from 'services';

/**
 * @param {FromToProps} param0 
 */
function FromTo({
    field,
    data, 
    changeFieldsMultiple, 
    countIndex,
    required = false, 
    setHasErrors = (_a, _b) => {},
    mainRegions,
    withAreas,
    onlyAreas = false,
    isInBalticIndex = false,
    placeFrom = 'placeFrom',
    placeTo = 'placeTo',
    regionFrom = 'regionFrom',
    regionTo = 'regionTo',
    checkRequiredMain = true,
    name = '',
    selectPortCustom,
}) {
    const [current, setCurrent] = useState(data);

    const selectPort = async (port) => {
        setCurrent(port);

        const value = _.pick(port, ['_id', 'name', 'areaParent']);
        const toChange = [{ index: countIndex, field, value }];

        if ([regionFrom, regionTo].includes(field)) {
            toChange.push({
                index: countIndex,
                field: field === regionFrom ? placeFrom : placeTo,
                value: {},
            });

            if (field === regionFrom) {
                toChange.push({ index: countIndex, field: 'bunkerPlace', value });
            }
        } else {
            const main = await api.getPortMainRegion(port._id);
            const mainValue = _.pick(main.data[0] || {}, ['_id', 'name', 'areaParent']);
            toChange.push({
                index: countIndex,
                field: field === placeFrom ? regionFrom : regionTo,
                value: mainValue,
            });
            toChange.push({ index: countIndex, field: 'bunkerPlace', value: mainValue });
        }

        changeFieldsMultiple(toChange);
    };

    useEffect(() => {
        setCurrent(data);
    }, [data]);

    useEffect(() => {
        if (required) {
            const hasError = !data || !data._id;
            if (checkRequiredMain && [regionFrom, regionTo].includes(field)) {
                setHasErrors(field, hasError);
            } else if (!checkRequiredMain) {
                setHasErrors(field, hasError);
            }
        }
    }, [current]);

    const handleChangeCustomValue = (value) => {
        changeFieldsMultiple([
            {
                index: countIndex,
                field,
                value,
            },
        ]);
    };

    return (
        <PortsAutoComplete 
            name={name}
            customValue={current ? current.name : ''}
            selectValue={selectPortCustom || selectPort}
            floatingLabelStyle={{ display: 'none' }}
            hintText={null}
            underlineStyle={{ display: 'none' }}
            inputStyle={{ fontSize: '10px' }}
            style={{ top: 'unset' }}
            menuStyle={{ width: '300px' }}
            popoverProps={{
                style: { width: '300px' },
            }}
            withAreas={withAreas}
            mainRegions={mainRegions}
            onlyAreas={onlyAreas}
            handleChangeCustomValue={handleChangeCustomValue}
            isInBalticIndex={isInBalticIndex}
        />
    );
}

export default React.memo(FromTo);

/**
 * @typedef {Object} FromToProps
 * @property {string} field
 * @property {*} data
 * @property {(_: any[]) => void} changeFieldsMultiple
 * @property {number} countIndex
 * @property {boolean} [required]
 * @property {Function} setHasErrors
 * @property {boolean} [mainRegions]
 * @property {boolean} [withAreas]
 * @property {boolean} [onlyAreas]
 * @property {boolean} [isInBalticIndex]
 * @property {string} [placeFrom]
 * @property {string} [placeTo]
 * @property {string} [regionFrom]
 * @property {string} [regionTo]
 * @property {boolean} [checkRequiredMain]
 * @property {string} [name]
 * @property {Function} [selectPortCustom]
 * @property {*} [bunkerPlace]
 * @property {string} [lay] used for getting fuel price on specific date
 */



// WEBPACK FOOTER //
// ./app/components/Hires/rowData/FromTo.jsx